<template>
  <fieldset class="formulate-buttons flex my-2 py-6 border-t-2 justify-between items-center flex-wrap gap-2">
    <FormulateInput
      v-show="
        typeof i18n.form.buttons !== 'undefined' &&
          typeof i18n.form.buttons.previous !== 'undefined' &&
          (typeof previousButton === 'undefined' || previousButton !== false)
      "
      type="button"
      v-on="$listeners.previous ? { click: $listeners.previous } : {}"
    >
      <arrow-left-white class="icon" />
      {{ i18n.form.buttons.previous }}
    </FormulateInput>

    <FormulateInput
      v-if="
        typeof i18n.form.buttons !== 'undefined' &&
          typeof i18n.form.buttons.submit !== 'undefined' &&
          (typeof submitButton === 'undefined' || submitButton !== false)
      "
      type="submit"
      :disabled="isLoading"
    >
      {{ i18n.form.buttons.submit }}
      <arrow-right-white class="icon" />
    </FormulateInput>
  </fieldset>
</template>

<script>
export default {
  name: 'FieldsControlButtons',
  components: {
    ArrowLeftWhite: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ArrowLeftWhite.vue'),
    ArrowRightWhite: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ArrowRightWhite.vue'),
  },
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    previousButton: {
      type: Boolean,
      default: true,
    },
    submitButton: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
